import {
  getCourseRequestDetail,
  updateCourseRequestStatus,
  useAppDispatch,
  useAppSelector,
} from '@redux'
import { Typography } from 'antd'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { Button } from 'src/common'
import { AppModal } from 'src/components/AppModal'
import { XCloseIcon } from 'src/components/Icon'
import { ECourseRequestStatus } from 'src/interfaces/course-request-management'

interface IAcceptCourseRequestDialogProps {
  open: boolean
  onClose: () => void
}

export default function AcceptCourseRequestDialog({
  open,
  onClose,
}: IAcceptCourseRequestDialogProps) {
  const dispatch = useAppDispatch()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { data: courseRequestDetailData } = useAppSelector(
    (state) => state.courseRequestManagement.courseRequestDetail
  )
  const { id: courseRequestId, course } = courseRequestDetailData || {}

  const handleAcceptCourseRequest = async () => {
    try {
      setIsSubmitting(true)
      await dispatch(
        updateCourseRequestStatus({
          courseRequestId: String(courseRequestId),
          payload: {
            response: ECourseRequestStatus.ACCEPTED,
          },
        })
      ).unwrap()

      setIsSubmitting(false)
      dispatch(getCourseRequestDetail(String(course?.id)))
      toast.success('Accept course creation request successfully!')
      onClose()
    } catch (error: any) {
      setIsSubmitting(false)
      toast.error(
        error?.message ||
          error?.data?.message ||
          'Something went wrong. Please try again'
      )
    }
  }

  return (
    <AppModal open={open} onClose={onClose} contentClassName="!px-8 !py-6">
      <div className="h-auto">
        <div className="flex items-center justify-center gap-4">
          <div>
            <h1 className="m-0 text-[24px]">
              Want to accept this Course creation request?
            </h1>
          </div>
          <div className="hover:opacity-75 cursor-pointer">
            <XCloseIcon width={16} height={16} onClick={onClose} />
          </div>
        </div>
      </div>

      <div className="flex flex-col max-w-[400px] mt-4 mb-8 mx-auto">
        <Typography
          style={{ color: '#424955FF', textAlign: 'center', fontSize: 16 }}
        >
          Are you sure you want to accept this request?
        </Typography>

        <Typography
          style={{
            color: '#424955FF',
            textAlign: 'center',
            fontSize: 16,
          }}
        >
          Once you have accepted the request, an email will be sent directly to
          the teacher and the course will be published.
        </Typography>
      </div>

      <div className="flex justify-center items-center my-2 mt-4 gap-4">
        <Button type="ghost" size="small" onClick={onClose}>
          Check Again
        </Button>

        <Button
          type="primary"
          size="small"
          loading={isSubmitting}
          onClick={handleAcceptCourseRequest}
        >
          Accept Request
        </Button>
      </div>
    </AppModal>
  )
}
